module.exports = __webpack_public_path__ + "img/timeentry-icon.befae24f.svg";